import { z } from 'zod';

export const BotEventTypeSchema = z.union([
  z.literal('ParticipantJoined'),
  z.literal('ParticipantLeft'),
]);

export const BotEventSubscriptionSchema = z.object({
  id: z.string().min(1), // botId
  eventTypes: z.array(BotEventTypeSchema),
});

export type BotEventType = z.infer<typeof BotEventTypeSchema>;
export type BotEventSubscription = z.infer<typeof BotEventSubscriptionSchema>;

export const EmptyBotEventSubscription: BotEventSubscription = {
  id: '',
  eventTypes: [],
};
